<template>
  <div class="app-container">
    <div class="index-tree-box">
      <type-tree ref="type_tree" @on-select="onSelect" @title-click="titleClick" />
      <div class="right-box">
          <list ref="list" @selRowData="onSelRowData">
            <template slot="toolbar-right" v-if="$permission.canWrite()" >
               <!-- <el-button type="success" plain @click="onImprot">导入</el-button>
               <el-button type="success" plain @click="onExport" >导出</el-button>
              <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
              <el-button type="danger" @click="delRows">删除</el-button> -->
              <el-button type="primary" @click="onbatchPrint" icon="el-icon-plus">批量打印</el-button>
            </template>
            <template slot="column" v-if="$permission.canWrite()">
              <el-table-column label="操作" fixed="right" align="center" width="130">
                <template slot-scope="{row}">
                  <el-button type="text" @click="edit(row)">编辑</el-button>
                  <el-button type="text" @click="onPrint(row)">打印</el-button>
                </template>
              </el-table-column>
            </template>
          </list>
      </div>
    </div>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <import-dialog ref="importDialog" @upload-success="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/basedata/codeprint/stock/list";
import editDialog from "@/components/basedata/codeprint/stock/editDialog";
import importDialog from "@/components/basedata/codeprint/stock/importDialog";

import typeTree from "@/components/basedata/codeprint/stock/type/tree";

// import list from "@/components/basedata/inventory/archives/list";
// import editDialog from "@/components/basedata/inventory/archives/editDialog";
// import importDialog from "@/components/basedata/inventory/archives/importDialog";
// import typeTree from "@/components/basedata/inventory/archives/type/tree";

export default {
  name: "rank",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    importDialog,
    typeTree,
  },
  data() {
    return {
      api: require("@/api/ba/product").default,
      select: {
        Id: null,
        Name: "",
      },
      selData:[]
    };
  },
  mounted() {
    this.$refs.type_tree.getData();
  },
  methods: {
    onImprot(){
       this.$refs.importDialog.open();
    },
    onExport() {
			this.$confirm("是否导出数据？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.$refs.list.onExport();
				})
				.catch(() => { });
		},
    onSelect(data) {
      console.log(data,"data");
      this.select.Id = data.ClassId;
      this.select.Name = data.ClassName;
      this.$refs.list.queryParamsAppend.IdChain=data.IdChain;
      this.$refs.list.getData({ IdChain: data.IdChain, });
      // this.reload();
    },  
    titleClick() {
      this.select.Id = null;
      this.select.Name = "";
      this.$refs.list.queryParamsAppend.IdChain=null;
      this.$refs.list.getData({ IdChain: null });
    },
    create() {
      console.log('select',this.select.Id);
      this.$refs.editDialog.openCreate({
        ClassId: this.select.Id,
        ClassName: this.select.Name,
      });
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      let list = rows.filter(item => {
        return item.IsExistProductStock === true;
      })
      if(list.length !== 0){
        this.$message.warning("删除的数据不能包含已被引用的存货");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.ProductId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    onSelRowData(data){
      this.selData = data
    },
    onPrint(row) {
      let ids = [row.ProductId]; // 创建包含单个ID的数组
      this.openPrintPage(ids);
    },
    onbatchPrint() {
      let ids = this.selData.map(item => item.ProductId); // 获取多个ID组成的数组
      this.openPrintPage(ids);
    },
    openPrintPage(ids) {
      let newpage = this.$router.resolve({
        path: '/stockPrint',
        query: {
          ids: JSON.stringify(ids) // 序列化数组为字符串
        }
      });
      window.open(newpage.href, '_blank');
    }
  },
};
</script>